import configuration from "../configuration/keys";
import { TAdminVersionStates, TCorePage } from "../Types";

export const ADMIN_VERSION_DEFAULT_STATES: TAdminVersionStates = {
  isActive: true,
  isUnderMaintenance: false,
  latestAdminVersion: configuration.version
};

export const MONITORED_KHATTABAT_PAGES: TCorePage[] = [
  "KHATTABAT_MATCHING_RESULTS",
  "KHATTABAT_M",
  "KHATTABAT_F"
];

// Refresh interval for Khattabat pages: 60000 ms (60 seconds)
export const KHATTABAT_PAGES_REFRESH_INTERVAL = 60000;

export const SESSION_HOURS_TIME_LIMIT = 8;
export const ONE_DAY_TOTAL_HOURS = 24;

export const MAX_KHATTABA_ASSIGNEES = 100;

export const MIN_KHATTABA_ASSIGNEES = 1;

export const KHATTABAT_ONE_O_TWO_MIN_QUALITY_MESSAGES = 50;

export const KHATTABAT_REACTIVATION_DELAY_DAYS = 30;

export const ONE_MONTH_RANGE = 32;

export const DEFAULT_KHATTABAT_AI_FLTER_STATUS_VALUE = {
  label: "All",
  value: "all"
};

export const HEADER_HEIGHT = 76;
export const WRAPPER_CONTENT_HEIGHT = 1110;
export const WRAPPER_HEIGHT_LOGIN = 1080;

export const SECTION_OPEN_STATES_STORAGE_KEY = "section_open_states";

export const FOOTER_HEIGHT = 36;
export const FOOTER_FONT_SIZE = 12;
